const ACCESS_TOKEN_KEY = "accessToken";
const REFRESH_TOKEN_KEY = "refreshToken";
const USER_KEY = "user";

const getActiveStorage = (): Storage => {
  return localStorage.getItem(ACCESS_TOKEN_KEY) ? localStorage : sessionStorage;
};

export const saveAuthData = (
  data: { token?: string; accessToken?: string; refreshToken?: string },
  user: object,
  rememberMe: boolean,
) => {
  const accessToken = data.accessToken || data.token;
  const refreshToken = data.refreshToken;

  if (!accessToken) {
    console.error("No access token provided to saveAuthData");
    return;
  }

  const targetStorage = rememberMe ? localStorage : sessionStorage;
  const otherStorage = rememberMe ? sessionStorage : localStorage;

  otherStorage.removeItem(ACCESS_TOKEN_KEY);
  otherStorage.removeItem(REFRESH_TOKEN_KEY);
  otherStorage.removeItem(USER_KEY);

  targetStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  if (refreshToken) {
    targetStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  } else {
    targetStorage.removeItem(REFRESH_TOKEN_KEY);
  }
  targetStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const saveRefreshedTokens = (
  accessToken: string,
  refreshToken?: string,
) => {
  const storage = getActiveStorage();
  storage.setItem(ACCESS_TOKEN_KEY, accessToken);
  if (refreshToken) {
    storage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  }
};

export const getAccessToken = (): string | null => {
  return (
    localStorage.getItem(ACCESS_TOKEN_KEY) ||
    sessionStorage.getItem(ACCESS_TOKEN_KEY)
  );
};

export const getRefreshToken = (): string | null => {
  return (
    localStorage.getItem(REFRESH_TOKEN_KEY) ||
    sessionStorage.getItem(REFRESH_TOKEN_KEY)
  );
};

export const getUser = (): any | null => {
  const userJson =
    localStorage.getItem(USER_KEY) || sessionStorage.getItem(USER_KEY);
  if (!userJson) return null;
  try {
    return JSON.parse(userJson);
  } catch (e) {
    console.error("Failed to parse user from storage", e);
    clearAuth();
    return null;
  }
};

export const clearAuth = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  sessionStorage.removeItem(ACCESS_TOKEN_KEY);
  sessionStorage.removeItem(REFRESH_TOKEN_KEY);
  sessionStorage.removeItem(USER_KEY);
  window.dispatchEvent(new Event("auth-cleared"));
};
